import styled from '@emotion/styled';
import { Col, Image, Row } from 'antd';
import { FaCheck } from 'react-icons/fa';
import { ORANGE, SECONDARY, YELLOW } from '../../shared/colors';
import { Layout } from '../shared/Layout';
import { Banner } from './components/Banner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { SECTION_1 } from './components/PageData/homePageData';

const Container = styled.div`
  background-color: white;

  .title {
    font-size: 20px;
    color: ${ORANGE};
    text-transform: uppercase;
    margin-bottom: 50px;
    font-family: 'Poppins-B';
    text-align: center;
  }

  .title::after {
    content: '';
    background: ${ORANGE};
    height: 5px;
    width: 100px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 5px;
    display: block;
    transform: translateY(1px);
    border-radius: 10px;
  }

  .home-body {
    max-width: 85%;
    margin: auto;
  }

  .section {
    color: black;
    display: flex;
    margin-bottom: 50px;

    > .text-description {
      margin-left: 150px;
    }

    .sectionHead {
      font-size: 25px;
      font-weight: bold;
      font-style: Poppins-B;
      color: ${YELLOW};
    }
  }

  .section-color {
    padding: 5% 5% 2% 8%;
    background-color: ${SECONDARY};
    min-height: 300px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 50px;
  }
`;

export const HomePage = () => {
  return (
    <Layout>
      <Container>
        <Banner />
        <div>
          <Row
            gutter={16}
            className='section'
            style={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Col>
              <h2
                className='title'
                style={{
                  marginTop: 20,
                }}
              >
                Qui est{' '}
                <span
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 20,
                  }}
                >
                  <span style={{ color: ORANGE }}>Moranj</span>
                  <span style={{ color: '#6d4c41' }}>E</span>
                  <span style={{ color: YELLOW }}>trade</span>
                </span>{' '}
                ?
              </h2>
            </Col>
          </Row>
          <Row
            className='section'
            style={{
              justifyContent: 'space-evenly',
              alignItems: 'center',
              marginTop: 0,
            }}
          >
            <Col xs={24} sm={12} md={6} xl={6}>
              <div className=''>
                <span
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 28,
                  }}
                >
                  <span style={{ color: ORANGE }}>Moranj</span>
                  <span style={{ color: '#6d4c41' }}>E</span>
                  <span style={{ color: YELLOW }}>trade</span>
                </span>
                <p
                  style={{
                    fontSize: 16,
                    fontFamily: 'Poppins-L',
                    color: 'grey',
                  }}
                >
                  {' '}
                  est une plateforme indépendante pour le marché des obligations
                  d'Afrique. Alliant analuses précises, navigation intuitive et
                  liaisons avec les acteurs financiers clés, elle répond aux
                  standards mondiaux tout en s'adaptant parfaitement aux
                  spécificités régionales.
                </p>
              </div>
            </Col>
            <Col xs={24} sm={12} md={4} xl={6}>
              <div className='text-description'>
                <p className='sectionHead'>Quelques avantages</p>
                <div style={{ color: 'grey' }}>
                  {SECTION_1.map((sec, i) => (
                    <p key={i}>
                      <FaCheck color={ORANGE} style={{ marginBottom: -2 }} />{' '}
                      {sec}
                    </p>
                  ))}
                </div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={6} xl={6}>
              <p className='sectionHead'>Nos atouts</p>
              <div
                style={{
                  fontSize: 16,
                  fontFamily: 'Poppins-L',
                  color: 'grey',
                }}
              >
                {SECTION_1.map((sec, i) => (
                  <p key={i}>
                    <FaCheck color={ORANGE} style={{ marginBottom: -2 }} />{' '}
                    {sec}
                  </p>
                ))}
              </div>
            </Col>
          </Row>
          <Row
            gutter={16}
            className='section'
            style={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Col>
              <h2 className='title'>Contactez-nous</h2>
            </Col>
          </Row>
          <Row
            className='section'
            style={{
              justifyContent: 'space-evenly',
              alignItems: 'center',
              margin: 'auto',
            }}
          >
            <Col xs={24} sm={12} md={8} xl={8}>
              <Image
                src='/assets/images/security.jpg'
                width={'70%'}
                // height={300}
                style={{ objectFit: 'contain', borderRadius: '50%' }}
                preview={false}
              />
            </Col>
            <Contact />
            <Col xs={24} sm={12} md={4} xl={6}>
              <div className='text-description'>
                <p className='sectionHead'>Votre sécurité, notre priorité</p>
                <div style={{ color: 'grey' }}>
                  {SECTION_1.map((sec, i) => (
                    <p key={i}>
                      <FaCheck color={ORANGE} style={{ marginBottom: -2 }} />{' '}
                      {sec}
                    </p>
                  ))}
                </div>
              </div>
            </Col>
            {/* <Section title='Section 3' body={<p>Contenu 3</p>} /> */}
          </Row>
        </div>
        <Footer />
      </Container>
    </Layout>
  );
};
